type EventHandler = (...args: any[]) => void;

export class EventEmitter {
  private events: Record<string, EventHandler[]> = {};

  // Subscribe to an event
  public on(eventName: string, handler: EventHandler) {
    if (!this.events[eventName]) {
      this.events[eventName] = [];
    }
    this.events[eventName].push(handler);
  }

  // Unsubscribe from an event
  public off(eventName: string, handler: EventHandler) {
    if (!this.events[eventName]) return;

    this.events[eventName] = this.events[eventName].filter(
      (h) => h !== handler
    );
  }

  // Emit an event with arguments
  public emit(eventName: string, ...args: any[]) {
    if (!this.events[eventName]) return;

    this.events[eventName].forEach((handler) => handler(...args));
  }

  // Clear all listeners (optional utility)
  public clear() {
    this.events = {};
  }
}
